<template>
  <div :class="$style.box">
    <div
      :class="[$style.top, packetStatus() == 3 ? $style.open : '' ]"
      :style="{ backgroundImage: `url(${ packetStatus() == 3 ? packet_open : packet_new})` }"
    >
      <div :class="$style.title" v-if="packetStatus() != 3">{{title}}</div>
      <div :class="$style.info">
        {{info}}
        <div v-if="packetStatus() == 3">已发放</div>
      </div>
    </div>
    <div
      v-if="!applyFlag"
      :class="[$style.bot, (packetStatus() == 0 || packetStatus() == 3 || packetStatus() == 5) && $style.gray, (packetStatus() == 2 || packetStatus() == 4) && $style.red]"
      @click="getPacket"
    >{{buttonName}}</div>
    <div v-if="applyFlag" :class="[$style.bot, $style.red]">{{'审核中'}}</div>
  </div>
</template>

<script>
import { CDN_URL } from "@/config";
import { mapActions } from "vuex";
import { Toast } from "vant";

export default {
  props: {
    apply_status: {
      type: [Number, String],
      default: 0
    },
    packet_status: {
      type: [Number, String],
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    turn: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      packet_new: `${CDN_URL}/packet/packet.png`,
      packet_open: `${CDN_URL}/packet/packet-open.png`,
      buttonName: "",
      applyFlag: false
    };
  },
  methods: {
    ...mapActions("packet", {
      toApply: "toApply"
    }),
    packetStatus() {
      let status = 0; // 0.不可领取 1.可领取 2.待审核 3.已拒绝 4.发放中 5.已通过
      switch (this.apply_status) {
        case 0: // 不可领取
          status = 0;
          this.buttonName = "不可领取";
          break;
        case 1: // 可领取
          status = 1;
          this.buttonName = "可领取";
          break;
        case 2: // 已领取
          if (this.packet_status == 0) {
            // 待审核
            status = 2;
            this.buttonName = "待审核";
            break;
          } else if (this.packet_status == 1) {
            // 已拒绝
            status = 3;
            this.buttonName = "已拒绝";
            break;
          } else if (this.packet_status == 2) {
            // 发放中
            status = 4;
            this.buttonName = "发放中";
            break;
          } else if (this.packet_status == 3) {
            // 已通过
            status = 5;
            this.buttonName = "已通过";
            break;
          }
          break;
      }
      return status;
    },
    // 点击领取红包
    async getPacket() {
      const status = this.packetStatus();
      if (status !== 1) return;
      console.log(this.turn);
      const r = await this.toApply(this.turn);
      console.log("r", r);
      if (r.ret !== 1) {
        return;
      }
      if (this.turn === "turn_14" || this.turn === "turn_4") {
        Toast("红包发放中，请耐心等待~");
        this.applyFlag = true;
      } else if (this.turn === "turn_21" || this.turn === "turn_25") {
        Toast("请联系客服领取红包~");
        this.applyFlag = true;
      }
      return;
    }
  }
};
</script>

<style lang="scss" module>
.box {
  width: 95px;
  height: 172px;
  // background-color: lightslategray;
  .top {
    width: 100%;
    height: 136px;
    background-repeat: no-repeat;
    background-size: contain;
    // background-color: black;
    background-position: 50% 20px;
    position: relative;
    > div {
      position: absolute;
    }
    .title {
      width: 100%;
      font-size: 10px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      top: 26px;
      left: 0;
    }
    .info {
      width: 100%;
      line-height: 20px;
      // background-color: black;
      padding: 0px 10px;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      top: 68px;
      left: 0;
      > div {
        font-weight: bold;
      }
    }
  }
  .open {
    background-size: 112px 148px;
    background-position: 58% -13px;
  }
  .bot {
    width: 95px;
    height: 28px;
    background: rgba(255, 206, 100, 1);
    border-radius: 5px;
    margin-top: 6px;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 28px;
  }
  .gray {
    background-color: #b1b1b1;
  }
  .red {
    color: #ec5e53;
  }
}
</style>